module.exports = __webpack_public_path__ + "static/media/monster.a4e61329.png";